import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const NetSuiteItemsProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();
    
    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `CommissionPlanTemplate/NetSuiteItems/${props.transactionType}`, method: 'GET', secure: true });
    }, [execute]);
    
    const value = { listRecords, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useNetSuiteItemsStore = () => React.useContext(Context);
